<template>
  <span :class="myClass + ' price-fmt'" :style="mysty">
    <i v-if="hasUnit" :style="unitStyle">{{isMinus && '-'}}￥</i><span class="interge" :style="smallInterge">{{intergePrice}}</span>.<span class="decimal" :style="smallDecimal">{{decimalPrice}}</span>
    <slot></slot>
    <slot name="text"></slot>
  </span>
</template>
<script>
import op from 'object-path'
  export default {
    props: ['price', 'mystyle', 'myclz', 'intergeSize', 'decimalSize', 'unit', 'unitSize', 'decimalPlace', 'isMinus'],
    data() {
      return {
      }
    },
    computed: {
      mysty() {
        return this.$props.mystyle
      },
      myClass() {
        return this.$props.myclz || ''
      },
      hasUnit() {
        return this.$props.unit !== undefined ? this.$props.unit : true
      },
      unitStyle() {
        let i = this.$props.unitSize || "11px"
        return [{"font-size": i}]
      },
      smallInterge() {
        let i = this.$props.intergeSize || "15px"
        return [{"font-size": i}]
      },
      smallDecimal() {
        let smDecimal = this.$props.decimalSize || "15px"
        return [{"font-size": smDecimal}]
      },
      intergePrice() {
        return op(this.separation(this.$props.price)).get('0') || 0
      },
      decimalPrice() {
        return op(this.separation(this.$props.price)).get('1')|| 0
      }
    },
    methods: {
      separation(value) {
        let result = Math.round(( +value / 100) * Math.pow(10, 2)) / Math.pow(10, 2) + ''
        if(this.decimalPlace) {
          result = (+result).toFixed(this.decimalPlace)
        }
        return result.split('.')
        // return (Math.round(( +value / 100) * Math.pow(10, 2)) / Math.pow(10, 2) + '').split('.');
      }
    },
    mounted() {
    }
  }
</script>
<style lang="less">
  .price-fmt {
    margin-right: 2px;
    font-size: 15px;
    color: rgb(192, 49, 49);
    i {
      font-size: 11px;
      font-style: normal;
    }
  }
</style>

